import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ori-toast-view',
  templateUrl: './toast-view.component.html',
  styleUrls: ['./toast-view.component.scss']
})
export class ToastViewComponent implements OnInit {

  @Input()
  public id: string;

  @Input()
  public title: string;

  @Input()
  public content: string;

  @Output()
  public hidden: EventEmitter<void> = new EventEmitter<void>();

  public constructor() {
  }

  public ngOnInit() {
    setTimeout(() => {
      const toast = $(`#${this.id}`);

      // @ts-ignore
      toast.toast({animation: true, autohide: true, delay: 5000})
        .toast('show');

      toast.on('hidden.bs.toast', t => {
        this.hidden.emit();
      });
    }, 100);
  }

}
